export default __webpack_public_path__ + "static/media/Sample.3726a6de.csv";